import { inject, Injectable } from "@angular/core";
import { ProjValuesService } from "./proj-values.service";
import { PreviewPlan } from "@shared/models";
import { getTwelveMonthsArray } from "@shared/functions/date.functions";

@Injectable({
  providedIn: "root",
})
export class PreviewTableService {
  projValuesService = inject(ProjValuesService);

  getPreviewTable(planType: string, projDefault: number): PreviewPlan[] {
    const previewTable: PreviewPlan[] = [];

    const { startMonth, projValues } = this.projValuesService.getProjValues(planType, projDefault);
    const imaxArray = this.getPreviewImaxArray(projValues);
    const months = getTwelveMonthsArray(startMonth);

    for (let i = 0; i < 12; i++) {
      previewTable.push({
        month: months[i],
        proj: projValues[i],
        imax: imaxArray[i],
      });
    }

    return previewTable;
  }

  private getPreviewImaxArray(projValues: number[]): number[] {
    const ghostProj = Array(8).fill(0);
    const projArray = ghostProj.concat(projValues);
    let imaxArray = [50040];
    for (let i = 8; i < projArray.length; i++) {
      let sumOfPrevProj = 0;
      for (let j = i - 8; j < i; j++) {
        sumOfPrevProj += projArray[j];
      }
      const BASE_VALUE_MINUTES = 64800;
      const PROSPECTIVE_MINUTES = 14760;
      const imaxValue = BASE_VALUE_MINUTES - sumOfPrevProj - PROSPECTIVE_MINUTES;
      imaxArray.push(imaxValue);
    }
    return imaxArray;
  }
}
